export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_21-e2779bb2f5b5bc6b4aec903f4b765cff.jpg";